/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React from "react"
import { Button, ContentSection, FooterSection, ModalTitle, TitleSection, Element, Row } from "trux"
import traceBotSuccess from "../../assets/img/TB-soccer-knee-spotlight.png"
import './ConfirmationDialog.css'

export const ConfirmationDialog = ({onClose, personalizeMoment}) => {

  return (
    <>
      <TitleSection
        onCloseClick={onClose}
      >
        <ModalTitle content="⭐️ Moment saved!" />
      </TitleSection>
      <ContentSection>
          <Row justifyContent="center">
            <Element className="trace-bot-success" tag="img" src={traceBotSuccess} alt='logo' />
          </Row>
      </ContentSection>
      <FooterSection>
        <Button
          className="go-back-to-game-button"
          trkAction="Back to game Pressed"
          content={`Go back to the game`}
          onClick={onClose}
          width="100%"
        />
        <Button
          className="personalize-now-button"
          trkAction="Personalize Pressed"
          primary
          content={`Personalize now`}
          onClick={personalizeMoment}
          width="100%"
        />
      </FooterSection>
    </>
  )
}